export default {
    title: 'colors',
    colors: {
        //main colors
        primary: '#3C3F85',
        secconday: '#6063A3',
        tertiary: '#9799CF',
        brownPrimary: '#C77600',
        brownSeccondary: '#E59724',
        browTertiary: '#FF9800',
        blue: '#1773E2',
        darkBlue: '#0A3466',

        //neutral colors
        white: '#FFFFFF',
        whiteSecconday: '#F8F8F8',
        lightGray: '#C7C7C7',
        gray: '#AEAEAE',
        dark: '#2C3941',

        //complementary collors
        orange: '#FF954E',
        lightGreen: '#47DED0',
        purple: '#9D86ED',
        green: '#B8D335',
        pink: '#FF77F1',

        //alert
        warning: '#FA143B',
        success: '#3EA849',
        infoOrange: '#FF8735',

        //gradiente
        gradient: '#1773E2'
    }
}